import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// French translations
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frValidation from './locales/fr/validation.json';
import frDashboard from './locales/fr/dashboard.json';
import frInventory from './locales/fr/inventory.json';
import frSales from './locales/fr/sales.json';
import frCustomers from './locales/fr/customers.json';
import frExpenses from './locales/fr/expenses.json';
import frRepairs from './locales/fr/repairs.json';
import frReturns from './locales/fr/returns.json';
import frQuotes from './locales/fr/quotes.json';
import frUsers from './locales/fr/users.json';
import frSettings from './locales/fr/settings.json';
import frAuth from './locales/fr/auth.json';
import frBundles from './locales/fr/bundles.json';
import frCommissions from './locales/fr/commissions.json';
import frCategories from './locales/fr/categories.json';
import frLogs from './locales/fr/logs.json';
import frProducts from './locales/fr/products.json';
import frInvoices from './locales/fr/invoices.json';

// English translations
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enValidation from './locales/en/validation.json';
import enDashboard from './locales/en/dashboard.json';
import enInventory from './locales/en/inventory.json';
import enSales from './locales/en/sales.json';
import enCustomers from './locales/en/customers.json';
import enExpenses from './locales/en/expenses.json';
import enRepairs from './locales/en/repairs.json';
import enReturns from './locales/en/returns.json';
import enQuotes from './locales/en/quotes.json';
import enUsers from './locales/en/users.json';
import enSettings from './locales/en/settings.json';
import enAuth from './locales/en/auth.json';
import enBundles from './locales/en/bundles.json';
import enCommissions from './locales/en/commissions.json';
import enCategories from './locales/en/categories.json';
import enLogs from './locales/en/logs.json';
import enProducts from './locales/en/products.json';
import enInvoices from './locales/en/invoices.json';

const resources: Resource = {
  fr: {
    common: frCommon,
    navigation: frNavigation,
    validation: frValidation,
    dashboard: frDashboard,
    inventory: frInventory,
    sales: frSales,
    customers: frCustomers,
    expenses: frExpenses,
    repairs: frRepairs,
    returns: frReturns,
    quotes: frQuotes,
    users: frUsers,
    settings: frSettings,
    auth: frAuth,
    bundles: frBundles,
    commissions: frCommissions,
    categories: frCategories,
    logs: frLogs,
    products: frProducts,
    invoices: frInvoices,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    validation: enValidation,
    dashboard: enDashboard,
    inventory: enInventory,
    sales: enSales,
    customers: enCustomers,
    expenses: enExpenses,
    repairs: enRepairs,
    returns: enReturns,
    quotes: enQuotes,
    users: enUsers,
    settings: enSettings,
    auth: enAuth,
    bundles: enBundles,
    commissions: enCommissions,
    categories: enCategories,
    logs: enLogs,
    products: enProducts,
    invoices: enInvoices,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'validation',
      'dashboard',
      'inventory',
      'sales',
      'customers',
      'expenses',
      'repairs',
      'returns',
      'quotes',
      'users',
      'settings',
      'auth',
      'bundles',
      'commissions',
      'categories',
      'logs',
      'products',
      'invoices',
    ],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

export default i18n;
